import AppConstants from '../config/app.constants';

let FuelSurchargeService = function ($http, $q) {

    let all = (searchText, status, offset, limit) => {
        return $http
            .get(AppConstants.api + `/fuel-surcharge`, {
                params: {
                    searchText,
                    status,
                    offset,
                    limit
                }
            })
            .then((res) => {
                return res.data
            })
    };
    let fuelSurchagePendingCustomers = () => {
        return $http
            .get(AppConstants.api + '/fuel-surcharge/fuel-surchage-pending-customers')
            .then((res) => {
                return res.data
            })
    }
    let fuelSurchagePendingCustomersFilters = (searchText, offset, limit, sortColumn, sortDir) => {
        return $http
            .get(AppConstants.api + '/fuel-surcharge/filter-pending-customers', {
                params: {
                    searchText,
                    offset,
                    limit,
                    sortColumn,
                    sortDir
                }
            })
            .then((res) => {
                return res.data
            })
    }
    let fuelSurchagePendingLocationsFilters = (searchText, offset, limit, sortColumn, sortDir) => {
        return $http
            .get(AppConstants.api + '/fuel-surcharge/filter-pending-locations', {
                params: {
                    searchText,
                    offset,
                    limit,
                    sortColumn,
                    sortDir
                }
            })
            .then((res) => {
                return res.data
            })
    }

    let fuelSurchageCustomers = (filter) => {
        return $http
            .get(AppConstants.api + '/fuel-surcharge/fuel-surchage-customers', {
                params: {
                    fuelSurchargeId: filter.fuelSurchargeId,
                    sortingKey: filter.sortingKey,
                    sortingDir: filter.sortingDir,
                    limit: filter.limit,
                    offset: filter.offset,
                }
            })
            .then((res) => {
                return res.data
            })
    }
    let fuelSurchargeLocations = (filter) => {
        return $http
            .get(AppConstants.api + '/fuel-surcharge/fuel-surchage-locations', {
                params: {
                    fuelSurchargeId: filter.fuelSurchargeId,
                    customerId: filter.customerId,
                    sortingKey: filter.sortingKey,
                    sortingDir: filter.sortingDir,
                    limit: filter.limit,
                    offset: filter.offset,
                }
            })
            .then((res) => {
                return res.data
            })
    }
    let create = (data) => {
        return $http
            .post(AppConstants.api + `/fuel-surcharge/create-fuel-surcharge`, data)
            .then((res) => {
                return res.data
            })
    }

    let get = (id) => {
        return $http
            .get(AppConstants.api + `/fuel-surcharge/${id}`)
            .then((res) => {
                return res.data
            })
    }

    let update = (id, data) => {
        return $http
            .post(AppConstants.api + `/fuel-surcharge/${id}`, data)
            .then((res) => {
                return res.data
            })
    }

    let remove = (id, branchId) => {
        return $http
            .delete(AppConstants.api + `/fuel-surcharge/delete`, {
                params: {
                    id,
                    branchId
                }
            })
            .then((res) => {
                return res.data
            })
    }

    // let fundingSourceLocation = (locationId, searchText, branchId, limit, offset) => {
    //     return $http
    //         .post(AppConstants.api + `/branch-funding-source/funding-source-location`, {
    //             locationId,
    //             searchText,
    //             branchId,
    //             limit,
    //             offset
    //         })
    //         .then((res) => {
    //             return res.data
    //         })
    // }

    return {
        all,
        create,
        fuelSurchagePendingCustomers,
        fuelSurchagePendingCustomersFilters,
        fuelSurchagePendingLocationsFilters,
        fuelSurchageCustomers,
        fuelSurchargeLocations,
        get,
        update,
        // remove
    };

};

FuelSurchargeService.$inject = ['$http', '$q']

export default FuelSurchargeService;


// WEBPACK FOOTER //
// ./client/app/services/fuel-surcharge.service.js